import _ from 'lodash';
import { setVersion } from './services/actions/actions';
import { UNDO_LIMIT, REDO_LIMIT } from './constants/constants';

export default class Version {
    static addNew = (state) => {
        let localState = (localStorage.getItem('localState') ? JSON.parse(localStorage.getItem('localState')) : {});
        let resumeVersion = (localStorage.getItem('resumeVersion') ? JSON.parse(localStorage.getItem('resumeVersion')) : {past: [], present: {}, future: []});
        Version.flushOld(localState, state);
        let { future, past, present } = resumeVersion;
        let newPast = (past.length > UNDO_LIMIT ? past.slice(`-${UNDO_LIMIT}`) : past);
        let newFuture = (future.length > REDO_LIMIT ? future.slice(`-${REDO_LIMIT}`) : future);
        const localState2 = {
            ...state,
            resume: present
        }
        localStorage.setItem('localState', JSON.stringify(localState2))
        const resumeVersion2 = {
            ...resumeVersion,
            future: [...newFuture],
            present: {...state.resume},
            past: [...newPast, state.resume]
        }
        localStorage.setItem('resumeVersion', JSON.stringify(resumeVersion2))
    }

    static undo = (dispatch, state) => {
        let localState = (localStorage.getItem('localState') ? JSON.parse(localStorage.getItem('localState')) : {});
        let resumeVersion = (localStorage.getItem('resumeVersion') ? JSON.parse(localStorage.getItem('resumeVersion')) : {past: [], present: state.resume, future: []});
        const { past, present, future } = resumeVersion
        const previous = past[past.length - 1]
        const newPast = past.slice(0, past.length - 1)
        localState = {
            ...state,
            resume: previous
        }
        localStorage.setItem('localState', JSON.stringify(localState))
        resumeVersion = {
            ...resumeVersion,
            past: newPast,
            present: previous,
            future: [present, ...future]
        }
        localStorage.setItem('resumeVersion', JSON.stringify(resumeVersion))
        dispatch(setVersion(previous))
    }

    static redo = (dispatch, state) => {
        let localState = (localStorage.getItem('localState') ? JSON.parse(localStorage.getItem('localState')) : {});
        let resumeVersion = (localStorage.getItem('resumeVersion') ? JSON.parse(localStorage.getItem('resumeVersion')) : {past: [], present: state.resume, future: []});
        const { past, present, future } = resumeVersion
        const next = future[0]
        const newFuture = future.slice(1)
        localState = {
            ...state,
            resume: next
        }
        localStorage.setItem('localState', JSON.stringify(localState))
        resumeVersion = {
            ...resumeVersion,
            past: [...past, present],
            present: next,
            future: newFuture
        }
        localStorage.setItem('resumeVersion', JSON.stringify(resumeVersion))
        dispatch(setVersion(next))
    }

    static flush = () => {
        if(localStorage.getItem('localState')) localStorage.removeItem('localState');
        if(localStorage.getItem('resumeVersion')) localStorage.removeItem('resumeVersion');
    }

    static flushOld = (localState, state) => {
        if(localState.currentResume != state.currentResume){
            localStorage.removeItem('localState');
            localStorage.removeItem('resumeVersion');
        }
    }

    static canUndo = () => {
        const cu = localStorage.getItem('resumeVersion') && JSON.parse(localStorage.getItem('resumeVersion')).past.length > 0;
        return cu;
    }

    static canRedo = () => {
        const cr = localStorage.getItem('resumeVersion') && JSON.parse(localStorage.getItem('resumeVersion')).future.length > 0;
        return cr;
    }

    static updateState = (state) => {
        let versionDifference = Version.validateNewRevision(state);
        if(versionDifference != 0)
            Version.addNew(state);
        setTimeout(() => Version.updateState(state), 10000);
    }

    static validateNewRevision = (state) => {
        const localState = (localStorage.getItem('localState') ? JSON.parse(localStorage.getItem('localState')) : {});
        const versionDifference = JSON.stringify(state).localeCompare(JSON.stringify(localState));
        return versionDifference;
    }
}